import React from 'react'
import { Icons, Image } from 'msp-components'
import useProduct from '@/hooks/use-product'
import JasminCommerceBox from '@/components/molecules/JasminCommerceBox/JasminCommerceBox'
import { ProductFlipCardProps } from './ProductFlipCard.types'

const ProductFlipCard = ({
  className = '',
  productCoverImageUrl,
  productId,
  imageAlt,
  productDetailImageUrl
}: ProductFlipCardProps) => {
  const product = useProduct(productId)

  return (
    <div className={`snap-center ${className}`}>
      <div
        className={
          'flip-container flip-card-perspective relative h-[400px] w-[300px] 2xl:h-[24vw] 2xl:min-h-[200px] 2xl:w-[18vw] 2xl:min-w-[150px]'
        }
      >
        <div
          className={
            'flip-card preserve-3d absolute h-full w-full transition-all duration-500 ease-in-out'
          }
        >
          <div
            className={
              'card-front backface-hidden absolute h-full w-full select-none'
            }
          >
            <div className={'relative h-full w-full overflow-hidden'}>
              <div
                className={
                  'absolute right-0 top-0 flex h-8 w-8 items-center justify-center bg-black/50 fill-white'
                }
              >
                <div
                  className={'ml-[2px] mt-[-2px] rotate-45 backdrop-blur-md'}
                >
                  <Icons iconName={'Close'} width={'16px'} height={'16px'} />
                </div>
              </div>
              <Image
                className={'h-full w-full object-cover'}
                src={productCoverImageUrl}
                alt={`${imageAlt || product?.name} cover`}
                ratio='1/4'
              />
            </div>
          </div>
          <div
            className={
              'rotate-y-180 backface-hidden absolute h-full w-full overflow-hidden bg-white'
            }
          >
            <div className={'flex h-full flex-col'}>
              <div className={'h-full w-full flex-1 overflow-hidden'}>
                <Image
                  className={'h-full w-full object-cover'}
                  src={productDetailImageUrl || productCoverImageUrl}
                  alt={imageAlt || product?.name}
                  ratio='1/4'
                />
              </div>
              <div className={'border-gray92 min-h-[30%] flex-none border'}>
                <JasminCommerceBox
                  data={{
                    productId: productId,
                    type: 'TILE'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductFlipCard
